var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSunsetHalf = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 12.128,
    viewBox: "0 0 20 12.128",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-362.42 -194.825)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "sunset-half-a",
    d: "M372.42,194.825a10,10,0,0,1,10,10,8.171,8.171,0,0,1-.254,2.028s-5,.066-9.746.066c-4.793,0-9.774.034-9.774.034a10.013,10.013,0,0,1,9.774-12.128Z",
    fill: "#ed7000"
  }), /*#__PURE__*/React.createElement("path", {
    className: "sunset-half-b",
    d: "M367.427,205.881a5.029,5.029,0,0,1,10.055,0",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    className: "sunset-half-b",
    y1: 1.723,
    x2: 0.366,
    transform: "translate(373.852 197.825)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    className: "sunset-half-b",
    x2: 0.367,
    y2: 1.723,
    transform: "translate(370.735 197.825)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    className: "sunset-half-b",
    y1: 1.439,
    x2: 1.016,
    transform: "translate(376.296 199.173)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    className: "sunset-half-b",
    x2: 1.016,
    y2: 1.439,
    transform: "translate(367.64 199.173)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    className: "sunset-half-b",
    y1: 0.883,
    x2: 1.525,
    transform: "translate(378.287 201.934)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    className: "sunset-half-b",
    x2: 1.541,
    y2: 0.854,
    transform: "translate(365.159 201.903)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    className: "sunset-half-c",
    d: "M364.42,206.426h16.089",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "square"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSunsetHalf);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/sunset-half.be4c42bb9c829638acac02b09dc500ec.svg";